import React, {createContext, useReducer} from 'react'

export const SET_PLANT_LIST = 'SET_PLANT_LIST'
export const SELECT_PLANT = 'SELECT_PLANT'
export const SET_SHOW_PLANT_POPUP = 'SET_SHOW_PLANT_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_PLANT_LIST:
      return { ...data, plant_list: payload.data }
    case SELECT_PLANT:
      return {
        ...data,
        selected_plant: payload.data.selected_plant,
        show_plant_popup: payload.data.show_plant_popup,
      }
    case SET_SHOW_PLANT_POPUP:
      return {
        ...data,
        show_plant_popup: payload.data,
        selected_plant: payload.data ? data.selected_plant : {},
      }
    default:
      return data
  }
}

const initialState = {
  plant_list: [],
  selected_plant: {},
  show_plant_popup: false,
}

const PlantStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <PlantContext.Provider value={[state, dispatch]}>
      {children}
    </PlantContext.Provider>
  )
}

export const PlantContext = createContext(initialState)
export default PlantStore
